import { Toaster } from "react-hot-toast";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CategoryPage from "./components/Category/CategoryPage";
import WebsiteDetails from "./components/Details/WebsiteDetails";
import HomePage from "./components/Home/HomePage";
import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/Layout/ScrollToTop";
import ListingPage from "./components/Listing/ListingPage";
import SubmitWebsite from "./components/Submit/SubmitWebsite";
import { AuthProvider } from "./context/AuthContext";
import AboutPage from "./pages/AboutPage";
import BlogPage from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              background: "#fff",
              color: "#1e293b",
              border: "2px solid #e2e8f0",
              borderRadius: "12px",
              fontSize: "14px",
              fontWeight: "600",
              boxShadow: "0 10px 25px -5px rgba(0,0,0,0.06)",
            },
          }}
        />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/categories" element={<CategoryPage />} />
            <Route path="/category/:slug" element={<ListingPage />} />
            <Route path="/websites" element={<ListingPage />} />
            <Route path="/top-50" element={<ListingPage isTop50 />} />
            <Route path="/website/:id" element={<WebsiteDetails />} />
            <Route path="/submit" element={<SubmitWebsite />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
